import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Link from 'next/link';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';
import AspectImage from '@components/Shared/AspectImage/AspectImage';
import { formatHttpsUrl, isUrlInternal, getUrlTarget } from '@utils/utils';
import PostCTAStyles from './PostCTA.styled';

const DynamicLink = ({ url, children, props }) => {
  if (isUrlInternal(url)) {
    return (
      <Link href={url} {...props}>
        {children}
      </Link>
    );
  } else {
    return (
      <a href={url} target={getUrlTarget(url)}>
        {children}
      </a>
    );
  }
};

DynamicLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  url: PropTypes.any,
  props: PropTypes.object,
};

const PostCTA = ({ cta }) => {
  const [imageAspect, setImageAspect] = useState(1);
  const [imageUrl, setImageUrl] = useState(cta.ctaImage.file.url);

  useWindowResize(() => {
    if (window.innerWidth < variables.desktop_breakpoint_extended) {
      setImageAspect(1);
      setImageUrl(
        cta.ctaImage.file.url + '?w=190&h=190&fit=thumb&q=100&fm=webp'
      );
    } else {
      setImageAspect(1);
      setImageUrl(cta.ctaImage.file.url + '?h=260&q=100&fm=webp');
    }
  }, [variables.desktop_breakpoint_extended]);

  return (
    <PostCTAStyles className="cta-card">
      <DynamicLink url={cta.firstCtaButtonUrl}>
        <div className="cta-image">
          <AspectImage
            behavior="fill-container"
            containerOrientation="landscape"
            aspectRatio={imageAspect}
            src={formatHttpsUrl(imageUrl)}
            alt={cta.ctaImage.description || cta.ctaImage.title}
          />
        </div>
        <div className="cta-content">
          <div className="cta-subline">
            <span className="label">{cta.ctaCustomCategory}</span>
          </div>
          <div className="cta-headline standard">{cta.ctaHeader}</div>
        </div>
      </DynamicLink>
    </PostCTAStyles>
  );
};

PostCTA.propTypes = {
  cta: PropTypes.shape({
    ctaCustomCategory: PropTypes.any,
    ctaHeader: PropTypes.any,
    ctaImage: PropTypes.shape({
      description: PropTypes.any,
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
      title: PropTypes.any,
    }),
    firstCtaButtonUrl: PropTypes.any,
  }),
};

export default PostCTA;
